<template>
  <div v-if="!loading && loaded">
    <div class="vx-card mb-4">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col lg:w-1/4 sm:w-1/1 w-full">
            <vs-input
              class="inputx mb-4 mt-1"
              v-model="collection.name"
              name="collectionName"
              :label="$t('Name')"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('collectionName')"
              >{{ errors.first("collectionName") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/1 w-full">
            <label class="vs-select--label">{{ $t("Position") }}</label>
            <v-select
              label="name"
              class="mb-4"
              name="collectionPosition"
              :options="collectionPositions"
              :value="
                collectionPositions.filter(
                  (x) => x.id == collection.position
                )[0].name
              "
              @input="changePosition"
              v-validate="{ required: true }"
              :reduce="(x) => x.id"
              dir="rtl"
            >
            </v-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('collectionPosition')"
              >{{ errors.first("collectionPosition") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/1 w-full">
            <vs-input
              class="inputx mb-4 mt-1"
              v-model="collection.priority"
              :label="$t('Priority')"
              v-validate="{ regex: '^([0-9]+)$' }"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('collectionPriority')"
              >{{ errors.first("collectionPPriority") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/1 w-full mt-6">
            <vs-button
              type="filled"
              class="float-right"
              @click.prevent="submitForm()"
              :disabled="disableSubmit"
              v-has-permission="permission257"
              >{{ $t("Save") }}</vs-button
            >
          </div>
        </div>
      </div>
    </div>
    <div v-cloak>
      <div class="vx-card">
        <div class="vx-card__body card-body">
          <div class="vx-row mb-6">
            <div class="vx-col lg:w-3/4 sm:w-1/1 w-full">
              <treeselect
                v-model="assignProductCollection.productId"
                name="product"
                :multiple="false"
                :placeholder="$t('Search')"
                :async="true"
                :load-options="loadOptions"
                v-validate="'required'"
                class="search-input"
                ref="product"
                @select="onProductSelected"
              />
            </div>
            <div class="vx-col lg:w-1/4 sm:w-1/1 w-full">
              <vs-button
                @click="assignProduct()"
                class="bg_l_green float-right mt-1"
                v-has-permission="permission250"
              >
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("AssignProductToCollection") }}
              </vs-button>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col w-full mb-base">
              <data-grid
                ref="grid"
                stripe
                :data-source="gridDataSource"
                :search-data="gridSearchData"
                :columns="[
                  { title: $t('PersianName'), sort: 'PersianName' },
                  { title: $t('Action'), sort: 'Action' },
                ]"
              >
                <template slot-scope="{ row }">
                  <td style="width: 87%">{{ row.persianName }}</td>
                  <td style="width: 10%">
                    <vs-button
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.prevent="unassignPro(row.id)"
                      class="d-inline"
                      v-has-permission="permission249"
                    ></vs-button>
                  </td>
                </template>
              </data-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters, mapActions } from "vuex";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import Treeselect from "@/components/CustomTreeSelect.vue";
import DataGrid from "@/components/datagrid/DataGrid";
const dict = {
  custom: {
    collectionName: {
      required: "لطفا نام مجموعه را وارد نمایید.",
    },
    collectionPosition: {
      required: "لطفا موقعیت را انتخاب نمایید.",
    },
    collectionPPriority: {
      regex: "تنها مجاز به وارد کردن مقادیر عددی می‌باشید.",
    },
  },
};
Validator.localize("fa", dict);

export default {
  name: "Content_management_ProductCollection_Managment",
  data() {
    var id = this.$route.params.id;
    return {
      permission249: "UnAssignProductsFromProductCollection",
      permission250: "AssignProductsToProductCollection",
      permission257: "ModifyProductCollection",
      gridDataSource: {
        type: "app",
        service: "/CMS/api/ProductForProductCollectionQuery/" + id,
      },
      gridSearchData: {
        keyword: "",
      },
      assignProductCollection: {},
      collectionPositions: [{ name: "صفحه نخست", id: 0 }],
      collection: {},
      disableSubmit: false,
      loaded: false,
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
  mounted() {
    this.load();
  },
  computed: {
    ...mapGetters({
      productCollection: "productCollection/details",
      loading: "productCollection/loading",
    }),
  },
  methods: {
    ...mapActions({
      fetchSingle: "productCollection/fetchSingle",
      updateCollection: "productCollection/update",
      assignProductToCollection: "productCollection/assignProductToCollection",
      fetchSearch: "sale/fetchActualSearchForCollection",
      unassignProductToCollection:
        "productCollection/unassignProductToCollection",
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchSingle(id).then(() => {
        this.collection = Object.assign({}, this.productCollection);
      });
      setTimeout(() => {
        this.loaded = true;
      }, 1000);
    },
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.fetchSearch(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.persianName,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onProductSelected(data) {
      this.assignProductCollection = {
        id: this.$route.params.id,
        productId: data.id,
      };
    },
    changePosition(PositionId) {
      this.collection.Position = PositionId;
    },
    unassignPro(productId) {
      var id = this.$route.params.id;
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.unassignProductToCollection({ id, productId }).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    assignProduct() {
      this.assignProductToCollection(this.assignProductCollection).then(() => {
        this.$vs.notify({
          title: "عملیات موفق",
          text: "محصول به مجموعه موردنظر افزوده شد!",
          color: "success",
        });
        this.$refs.grid.renderGrid();
      });
      this.$refs.product.clear();
    },
    submitForm() {
      this.disableSubmit = true;
      this.updateCollection(this.collection)
        .then(() => {
          this.$swal({
            position: "center-center",
            type: "success",
            text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
            showConfirmButton: false,
            timer: 2000,
          });
          this.disableSubmit = false;
        })
        .catch((err) => (this.disableSubmit = false));
    },
  },
  components: {
    DataGrid,
    Treeselect,
    "v-select": vSelect,
  },
};
</script>
